import React from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import { LayoutDashboard, Radio, BookOpen, TrendingUp, Search as SearchIcon, ShieldCheck } from 'lucide-react';
import { Dashboard } from './components/Dashboard';
import { SignalBrowser } from './components/SignalBrowser';
import { AnalysisViewer } from './components/AnalysisViewer';
import { PredictionBoard } from './components/PredictionBoard';
import { Search } from './components/Search';
import { Diagnosis } from './components/Diagnosis';

const NAV_ITEMS = [
  { to: '/', label: 'Dashboard', Icon: LayoutDashboard },
  { to: '/signals', label: 'Signals', Icon: Radio },
  { to: '/search', label: 'Search', Icon: SearchIcon },
  { to: '/analyses', label: 'Analyses', Icon: BookOpen },
  { to: '/predictions', label: 'Predictions', Icon: TrendingUp },
  { to: '/diagnosis', label: 'Diagnosis', Icon: ShieldCheck },
];

export default function App() {
  return (
    <BrowserRouter>
      <div className="page-layout">
        <header className="page-nav">
          <div className="container">
            <div className="row">
              <div className="brand-mark" />
              <span style={{ fontFamily: 'var(--font-display)', fontWeight: 600, letterSpacing: '-0.01em', color: 'var(--color-text-primary)' }}>
                Sentinel
              </span>
              <span style={{ color: 'var(--color-text-muted)', fontWeight: 500, fontSize: '0.875rem' }}>
                / Intelligence
              </span>
            </div>
            <nav className="row" style={{ gap: 'var(--space-6)' }}>
              {NAV_ITEMS.map(({ to, label, Icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  end={to === '/'}
                  className={({ isActive }) =>
                    `nav-link${isActive ? ' nav-link-active' : ''}`
                  }
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
                >
                  <Icon size={14} strokeWidth={1.75} />
                  {label}
                </NavLink>
              ))}
            </nav>
          </div>
        </header>
        <main className="page-main">
          <div className="container">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/signals" element={<SignalBrowser />} />
              <Route path="/search" element={<Search />} />
              <Route path="/analyses" element={<AnalysisViewer />} />
              <Route path="/predictions" element={<PredictionBoard />} />
              <Route path="/diagnosis" element={<Diagnosis />} />
            </Routes>
          </div>
        </main>
      </div>
    </BrowserRouter>
  );
}
